import React, { PropsWithChildren } from 'react';

import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import bannerBlockStylesCss from 'components/ModularBlocks/BlockStyle/bannerBlockStylesCss';
import blockStylesCss from 'components/ModularBlocks/BlockStyle/blockStylesCss';

import { BlockStyleI } from 'interfaces/content-stack/contentStack.types';

import { combineBlockStyles } from 'utils/blockStyleUtils';
import { autoOptimizeImage } from 'utils/functions';

interface BoxContainerStyledProps {
  $blockStyle?: any;
  $promoBanners?: boolean;
  $backgroundImageUrl?: string;
  $backgroundColor?: string;
}

export const BoxContainer = styled.div<BoxContainerStyledProps>`
  &.container-flush {
    .content-container > div {
      padding-top: 0;
      padding-bottom: 0;
    }

    &.container,
    .container {
      padding: 0;
    }
  }

  &.page-wrapper {
    overflow: hidden;
  }

  .video-wrapper {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;

    // important is used in case height / width is set on the iframe
    iframe {
      height: 100% !important;
      left: 0;
      position: absolute;
      top: 0;
      width: 100% !important;
    }
  }

  ${ifProp(
    '$promoBanners',
    css`
      ${bannerBlockStylesCss}
    `
  )}

  ${blockStylesCss}

  ${(props) => props.$backgroundImageUrl && `background-image: url(${props.$backgroundImageUrl});`}
  ${(props) => props.$backgroundColor && `background-color: ${props.$backgroundColor};`}
`;

interface BlockStyleProps {
  blockStyle?: BlockStyleI[];
  className?: string;
  promoBanners?: any;
  $my?: number;
}

const BlockStyle: React.FC<PropsWithChildren<BlockStyleProps>> = ({
  blockStyle = [],
  className,
  children,
  promoBanners,
  ...props
}) => {
  const combinedBlockStyles: any = combineBlockStyles(blockStyle);
  const combinedClassName = (className || '') + ' ' + combinedBlockStyles?.customCss?.cssClassName;
  const backgroundImageUrl = autoOptimizeImage(blockStyle[0]?.background?.backgroundImage?.url);
  const backgroundColor = blockStyle[0]?.background?.backgroundColor;

  return (
    <BoxContainer
      $blockStyle={combinedBlockStyles}
      className={combinedClassName.trim()}
      $promoBanners={!!promoBanners}
      $backgroundImageUrl={backgroundImageUrl}
      $backgroundColor={backgroundColor}
      {...props}
    >
      {children}
    </BoxContainer>
  );
};

export default React.memo(BlockStyle);
